// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import SearchInput from '@aytm/app/stats/page/components/SearchInput'

const itemTemplate = option => (option.hidden ? null : <span dangerouslySetInnerHTML={{ __html: option.text }}></span>)

const VerbatimControls = ({ model, data, features, isSurveyGuest, onConfigChange }) => {
  const { config, survey, tagsList } = model

  const amount = useMemo(
    () =>
      Object.keys(data.controls.config.verbatim).filter(key => 0 < data.controls.config.verbatim[key].options?.length)
        .length + (2 > data.controls.viewModes.options.length || data.controls.viewModes.disabled ? 0 : 1),
    [data.controls.config.verbatim, data.controls.viewModes]
  )

  const searchInputSurvey = useMemo(() => {
    return { codeBooks: survey.codeBooks }
  }, [survey.codeBooks])

  return (
    <>
      {data.controls.config != undefined && data.controls.config.verbatim != undefined
        ? Object.keys(data.controls.config.verbatim).map(key =>
            'search' == key ? (
              <div
                key="param-search"
                className="p-fluid p-field p-col"
                style={{
                  width: `calc(100% - ${amount} * 28% - ${isSurveyGuest ? amount : amount + 1} * 10px - ${
                    isSurveyGuest ? 0 : '30px'
                  })`
                }}
              >
                <SearchInput
                  survey={searchInputSurvey}
                  tagsList={tagsList}
                  search={config.search}
                  isTagsManagementDisabled={features.oe_tags_view.disabled}
                  isSentimentsManagementDisabled={features.oe_sentiments_view.disabled}
                  onSearchChange={value => onConfigChange('search', Object.assign({}, config.search, value))}
                />
              </div>
            ) : 0 < data.controls.config.verbatim[key].options.length ? (
              <div key={`param-${key}`} className="p-field p-col-param">
                <Dropdown
                  className="p-dropdown-rounded"
                  value={config[key]}
                  options={data.controls.config.verbatim[key].options}
                  optionValue="key"
                  optionLabel="text"
                  optionDisabled="disabled"
                  itemTemplate={itemTemplate}
                  fixedDropdownDir="bottom"
                  disabled={data.controls.config.verbatim[key].disabled}
                  onChange={
                    data.controls.config.verbatim[key].disabled ? null : event => onConfigChange(key, event.value)
                  }
                />
              </div>
            ) : null
          )
        : null}
    </>
  )
}

VerbatimControls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  isSurveyGuest: PropTypes.bool,
  onConfigChange: PropTypes.func
}

VerbatimControls.displayName = 'VerbatimControls'

export default VerbatimControls
